import ProgramIcon from '../../assets/customIcons/programIcon';
import ApplicantProcessIcon from '../../assets/customIcons/applicantProcess';

import { PROGRAMS, TEMPLATES_APP_PROCESS } from '../../constants/routes';
import type { ReactElement } from 'react';

/**
 * Defines the primary navigation links for the application's side navigation.
 * Each link includes an icon, title, route path, and availability flag.
 *
 * @interface PrimaryLink
 * @property {ReactElement} icon - The icon to display for the link.
 * @property {string} title - The display name of the navigation link.
 * @property {string} linkTo - The route path the link navigates to.
 * @property {boolean} available - Whether the link should be shown in the navigation.
 */
interface PrimaryLink {
	icon: ReactElement;
	title: string;
	linkTo: string;
	available: boolean;
}

/**
 * Defines the primary navigation links for the application's side navigation.
 * Each link includes an icon, title, route path, and availability flag.
 *
 * @constant
 * @type {PrimaryLink[]}
 */
export const PrimaryLinks: PrimaryLink[] = [
	{
		icon: <ProgramIcon width={'28px'} isMulti />,
		title: 'Programs',
		linkTo: PROGRAMS,
		available: true
	},
	{
		icon: (
			<ApplicantProcessIcon
				isTemplate={true}
				isActive={false}
				width="28px"
				status={undefined}
				isBlueprint={false}
				isCurrentStage={false}
				isArchived={false}
				isWarning={false}
				customColor={undefined}
			/>
		),
		title: 'Templates',
		linkTo: TEMPLATES_APP_PROCESS,
		available: true
	}
];
